class ApiCallStorageInterface {
  register = (name, value) => {
    throw new Error("register method not implemented");
  };
  get = name => {
    throw new Error("get method not implemented");
  };
  set = (name, value) => {
    throw new Error("set method not implemented");
  };
}
export { ApiCallStorageInterface };